import type WebSocket from 'ws';
import type { LogFn } from '../../log.js';
import type { CliE2eeRuntime } from '../../lib/e2ee/index.js';
import { PreviewEnvironmentFirehoseSink } from './firehose-sink.js';
import {
  createPreviewEnvironmentManagerState,
  snapshotPreviewEnvironmentTails,
  type PreviewEnvironmentManagerState,
} from './state.js';
import type { PreviewEnvironmentManagerRuntime } from './runtime.js';
import { registerPreviewEnvironmentExitCleanup } from './register-exit-cleanup.js';

export type PreviewEnvironmentManagerDeps = {
  state: PreviewEnvironmentManagerState;
  runtime: PreviewEnvironmentManagerRuntime;
  firehoseSink: PreviewEnvironmentFirehoseSink;
};

export function createPreviewEnvironmentManagerDeps(options: {
  getWs: () => WebSocket | null;
  log: LogFn;
  getBridgeRoot?: () => string;
  e2ee?: CliE2eeRuntime;
  getPreviewWorktreeParentPath?: (environmentId: string) => string | undefined;
}): PreviewEnvironmentManagerDeps {
  const state = createPreviewEnvironmentManagerState();
  registerPreviewEnvironmentExitCleanup(state);
  const firehoseSink = new PreviewEnvironmentFirehoseSink({
    getTails: (environmentId) => snapshotPreviewEnvironmentTails(state, environmentId),
    isPipedCaptureEnabled: (environmentId) => state.pipedCaptureByServerId.get(environmentId) === true,
    e2ee: options.e2ee,
  });
  const runtime: PreviewEnvironmentManagerRuntime = {
    state,
    getWs: options.getWs,
    log: options.log,
    getBridgeRoot: options.getBridgeRoot ?? (() => process.cwd()),
    getPreviewWorktreeParentPath: options.getPreviewWorktreeParentPath,
    firehoseSink,
    e2ee: options.e2ee,
  };
  return { state, runtime, firehoseSink };
}
